import React from 'react';
import { CircularProgress, Box } from '@mui/material';

const LoadingSpinner = (height) => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: height,
        backgroundColor: 'black',
      }}
    >
      <CircularProgress />
    </Box>
  );
};

export default LoadingSpinner;
